module.exports = __webpack_public_path__ + "img/glassquality_1.7aa39b45.png";